/**
 * HERO SLIDER FULLSCREEN
 * Gestion du slider hero avec navigation flèches et dots
 */

class HeroSliderFullscreen {
  constructor(slider) {
    this.slider = slider;
    this.slides = slider.querySelectorAll('.hero-slide');
    this.dots = slider.querySelectorAll('.hero-dot');
    this.prevBtn = slider.querySelector('.hero-arrow-prev');
    this.nextBtn = slider.querySelector('.hero-arrow-next');
    
    this.currentSlide = 0;
    this.totalSlides = this.slides.length;
    this.autoplayTimer = null;
    
    // Récupérer les paramètres
    this.autoplay = slider.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(slider.dataset.autoplaySpeed) * 1000 || 5000;
    
    // Initialiser
    this.init();
  }
  
  init() {
    if (this.totalSlides <= 1) return; // Pas de slider si 1 seul slide
    
    // Événements navigation flèches
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.goToPrev());
    }
    
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.goToNext());
    }
    
    // Événements dots
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.goToSlide(index));
    });
    
    // Clavier navigation
    document.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') this.goToPrev();
      if (e.key === 'ArrowRight') this.goToNext();
    });
    
    // Touch/Swipe sur mobile
    this.initTouchEvents();
    
    // Autoplay
    if (this.autoplay) {
      this.startAutoplay();
      
      // Pause au hover
      this.slider.addEventListener('mouseenter', () => this.stopAutoplay());
      this.slider.addEventListener('mouseleave', () => this.startAutoplay());
    }
  }
  
  goToSlide(index) {
    // Retirer active du slide actuel
    this.slides[this.currentSlide].classList.remove('active');
    this.dots[this.currentSlide].classList.remove('active');
    
    // Ajouter active au nouveau slide
    this.currentSlide = index;
    this.slides[this.currentSlide].classList.add('active');
    this.dots[this.currentSlide].classList.add('active');
    
    // Réinitialiser autoplay
    if (this.autoplay) {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }
  
  goToNext() {
    const nextSlide = (this.currentSlide + 1) % this.totalSlides;
    this.goToSlide(nextSlide);
  }
  
  goToPrev() {
    const prevSlide = (this.currentSlide - 1 + this.totalSlides) % this.totalSlides;
    this.goToSlide(prevSlide);
  }
  
  startAutoplay() {
    this.autoplayTimer = setInterval(() => {
      this.goToNext();
    }, this.autoplaySpeed);
  }
  
  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }
  
  initTouchEvents() {
    let touchStartX = 0;
    let touchEndX = 0;
    
    this.slider.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    
    this.slider.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      this.handleSwipe(touchStartX, touchEndX);
    }, { passive: true });
  }
  
  handleSwipe(startX, endX) {
    const swipeThreshold = 50; // Minimum distance pour swipe
    const diff = startX - endX;
    
    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        // Swipe gauche → Slide suivant
        this.goToNext();
      } else {
        // Swipe droite → Slide précédent
        this.goToPrev();
      }
    }
  }
}

// Initialiser tous les sliders au chargement de la page
document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.hero-slider-fullscreen');
  sliders.forEach(slider => {
    new HeroSliderFullscreen(slider);
  });
});

// Support Shopify Theme Editor (reload si changement dans le Customizer)
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    const sliders = document.querySelectorAll('.hero-slider-fullscreen');
    sliders.forEach(slider => {
      new HeroSliderFullscreen(slider);
    });
  });
}